export default {
      id: "iphone8-usage",
      viewBox: "0 0 443 704",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#iphone8",
      toString: function () {
        return this.url;
      }
    }